export const privacyPreferences = {
	name: 'privacy_preferences'
} as const;

export const jwtToken = {
	name: 'jwt_token',
	maxAge: 60 * 60
} as const;
